import React, { useContext } from 'react';
import { SurveyPageContext } from '../context/SurveyPageContext';
import { getPage } from '../../utils/paginator';
import QuestionPage from '../question-page/QuestionPage';

const Container: React.FunctionComponent = () => {
  const { paginatedSurvey, surveyPage } = useContext(SurveyPageContext);

  if (paginatedSurvey?.has(surveyPage)) {
    const currentQuestionPage = getPage({
      paginatedSurvey,
      page: surveyPage,
      defaultValue: [],
    });
    return <QuestionPage questions={currentQuestionPage} />;
  }

  return <></>;
};

Container.displayName = 'Container';

export default Container;
